export const stringUtils = {
  escapeSpecials: (string: string): string => {
    const pattern = "\\\\";
    const regexp = new RegExp("[" + pattern + "]", "g");
    return string.replace(regexp, "");
  },

  trimLeft: (string: string): string => {
    return string.replace(/^\s+/, "");
  },

  trimRight: (string: string): string => {
    return string.replace(/\s+$/, "");
  },
};

export const globalUtils = {
  setLocation: (target: Location | string) => {
    // TODO
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.location = target;
  },
};

export type NextValueFn = () => number;

/** Parameterless function which returns previous value + 1.
 * @returns next Value
 */
function nextValue(): number {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return ++this.value;
}

export const coreUtils = {
  /**
   * Creates a self incrementing function.
   *
   * @example
   * var foo = counter();
   * foo(); // -> 1
   * foo(); // -> 2
   *
   * @param [start=1] initial value
   * @returns the initialized nextValue() function
   */
  counter: (start = 1): NextValueFn => {
    return window.o_util.core.bind({ value: (start || 1) - 1 }, nextValue);
  },
};

export interface Util {
  string: typeof stringUtils;
  global: typeof globalUtils;
  core: typeof coreUtils;
}

export const util = {
  string: stringUtils,
  global: globalUtils,
  core: coreUtils,
};
